// TODO: refactor function and references into window-utilities.ts
export function scrollToSection(event: Event, id: string): void {
  event.preventDefault();
  const el = document.getElementById(id);
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
  } else {
    window.location.hash = id;
  }
}
